import { ClientResponse } from '@commercetools/platform-sdk';

import { ctApi } from '@/api';
import {
  ProductsByKeys,
  ProductsByKeysResponse,
  ProductsByKeysVariables,
} from '@/graphql/productsByKeys';
import { NutsProductProjection } from '@/utils/productProjection';
import { reportError } from '@/utils/reportError';

export async function productsByKeys(keys: string[], locale?: ProductsByKeysVariables['locale']) {
  try {
    if (keys.length === 0) return [];
    const variables: ProductsByKeysVariables = {
      keys: `key:${keys.join(',')}`,
      limit: keys.length,
      locale,
    };

    const response = (await ctApi
      .graphql()
      .post({
        body: {
          query: ProductsByKeys,
          variables,
        },
      })
      .execute()) as unknown as ClientResponse<ProductsByKeysResponse>;
    const { results } = response.body.data.productProjectionSearch;
    return results.map((result) =>
      NutsProductProjection.fromQueryResult(result, { skipInvalidVariants: true }),
    );
  } catch (err) {
    reportError(err, 'Failed to fetch products', { keys: keys.join(',') });
    return [];
  }
}
